(function () {
  const allowMultipleOpen = false;

  function closestByClass(el, className) {
    while (el && el !== document.body) {
      if (el.classList && el.classList.contains(className)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function openPanel(item) {
    const answer = item.querySelector('.accordion__answer');
    const button = item.querySelector('.accordion__question-button');

    if (!answer || !button) return;

    item.setAttribute('data-open', 'true');
    button.setAttribute('aria-expanded', 'true');

    item.classList.add('is-open');

    answer.style.maxHeight = answer.scrollHeight + 'px';
  }

  function closePanel(item) {
    const answer = item.querySelector('.accordion__answer');
    const button = item.querySelector('.accordion__question-button');

    if (!answer || !button) return;

    item.setAttribute('data-open', 'false');
    button.setAttribute('aria-expanded', 'false');

    item.classList.remove('is-open');

    answer.style.maxHeight = '0px';
  }

  function togglePanel(item) {
    const isOpen = item.getAttribute('data-open') === 'true';

    if (isOpen) {
      closePanel(item);
    } else {
      if (item.parentElement) {
        const siblings =
          item.parentElement.querySelectorAll('.accordion__item');
        if (!allowMultipleOpen) {
          siblings.forEach(function (sib) {
            if (sib !== item && sib.getAttribute('data-open') === 'true') {
              closePanel(sib);
            }
          });
        }
      }
      openPanel(item);
    }
  }

  function initAccordion(root) {
    const items = root.querySelectorAll('.accordion__item');

    items.forEach(function (item, index) {
      const question = item.querySelector('.accordion__question');
      const button = item.querySelector('.accordion__question-button');
      const answer = item.querySelector('.accordion__answer');
      const titleEl = item.querySelector('.accordion__question-title');

      if (!question || !button || !answer) return;

      const qId =
        'accordion-q-' + index + '-' + Math.random().toString(36).slice(2, 7);
      const aId =
        'accordion-a-' + index + '-' + Math.random().toString(36).slice(2, 7);

      button.setAttribute('type', 'button');
      button.setAttribute('aria-controls', aId);
      button.setAttribute('aria-expanded', 'false');

      answer.setAttribute('id', aId);
      answer.setAttribute('role', 'region');
      answer.setAttribute('aria-labelledby', qId);

      item.setAttribute('data-open', 'false');
      answer.style.overflow = 'hidden';
      answer.style.maxHeight = '0px';
      answer.style.transition = 'max-height 250ms ease';

      if (titleEl) {
        titleEl.setAttribute('id', qId);
      }

      const clickableEls = [button, question];
      clickableEls.forEach(function (el) {
        el.addEventListener('click', function (evt) {
          if (el === button) evt.stopPropagation();
          togglePanel(item);
        });
      });

      button.addEventListener('keydown', function (evt) {
        const code = evt.key;
        if (code === 'Enter' || code === ' ') {
          evt.preventDefault();
          togglePanel(item);
        }
      });
    });
  }

  // Create accordion API object
  const accordionAPI = {
    initAccordion: initAccordion,
    openPanel: openPanel,
    closePanel: closePanel,
    togglePanel: togglePanel,
    closestByClass: closestByClass,
  };

  // Expose functions globally for browser usage and testing
  window.AccordionTest = accordionAPI;

  // Export for module usage (works in Node.js testing environment)
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = accordionAPI;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach(initAccordion);
  });
})();
